<template>
  <el-select
    :value="localValue"
    @input="$emit('input', $event)"
    placeholder="请选择排课方案"
    clearable style="width: 100%">
    <el-option v-for="(item,index) in items" :label="item.schemeName" :value="item.id" :key="index"></el-option>
  </el-select>
</template>
<script>
  export default {
    props: {
      value: null,
      yearId: {
        type: String,
        default: '',
      },
      schoolId: {
        type: String,
        default: '',
      },
      termId: {
        type: String,
        default: '',
      },
      campusId: {
        type: String,
        default: '',
      }
    },
    watch: {
      value(val){
        this.localValue = val
      },
      yearId(){
        this.query();
      },
      termId(){
        this.query();
      },
      termId(){
        this.query();
      },
      schoolId(){
        this.query();
      },
      campusId(){
        this.query();
      },
    },
    data() {
      return {
        localValue: this.value,
        items:[]
      }
    },
    methods: {
      query(){
        let vm = this
        if (!vm.campusId) {
          http.get(InterfacePrefix['choose_course'] + "/pickCouese/getCurseScheme/" + vm.yearId + "/" + vm.termId + "/" + vm.schoolId + "/" + vm.campusId).then(function (xhr) {
            if (xhr.data.code) return // 异常情况有公共处理
            vm.items = xhr.data
          })
        }
      },
    },
    mounted() {
      this.query()
    },
  }

</script>



// WEBPACK FOOTER //
// src/commonplugin/chose_param/chooseCurseScheme.vue